import React from 'react';
import { Row, Statistic } from 'antd';
import {
  AppstoreOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { SummaryCard, SummaryCol } from '../styles';

interface SummaryStatsProps {
  total?: number;
  running?: number;
  endToday?: number;
}

const SummaryStatistics: React.FC<SummaryStatsProps> = ({
  total = 0,
  running = 0,
  endToday= 0,
}) => (
  <Row gutter={[16, 16]} style={{ marginTop: 24 }} wrap>
    <SummaryCol xs={24} sm={12} md={8} lg={6} xl={4}>
      <SummaryCard bordered={false}>
        <Statistic title="전체 슬롯" value={total} prefix={<AppstoreOutlined />} />
      </SummaryCard>
    </SummaryCol>
    <SummaryCol xs={24} sm={12} md={8} lg={6} xl={4}>
      <SummaryCard bordered={false}>
        <Statistic
          title="구동 중"
          value={running}
          prefix={<ClockCircleOutlined />}
          valueStyle={{ color: '#10B981' }}
        />
      </SummaryCard>
    </SummaryCol>
    <SummaryCol xs={24} sm={12} md={8} lg={6} xl={4}>
      <SummaryCard bordered={false}>
        <Statistic
          title="당일 종료"
          value={endToday}
          prefix={<CloseCircleOutlined />}
          valueStyle={{ color: '#EF4444' }}
        />
      </SummaryCard>
    </SummaryCol>
  </Row>
);

export default SummaryStatistics;
